// extracted by mini-css-extract-plugin
export default {"label":"Field_label__-JUe2"};